/** @format */

export type PriceModifier = {
    id: string;
    modelId: number;
    present: boolean;
    value: number;
    declineReason: DeclineReason | null;
};

export enum DeclineReason {
    NOT_RECEIVED = 'not-received',
    ACCESSORY_BROKEN = 'accessory-broken',
    POOR_RECHARGE = 'poor-recharge',
    NOT_PURCHASED = 'not-purchased',
}
